

const GetCompassCardReducer = (state = { type: 'LOADING_COMPASS_CARD_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_COMPASS_CARD_VIEW_ACTION':
            return action
        default:
            return state
    }
}

const GetCompassDetailReducer = (state = { type: 'LOADING_COMPASS_DETAIL_VIEW_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'SUCCESS_COMPASS_DETAIL_VIEW_ACTION':
            return action
        default:
            return state
    }
}
// const GetCompassKpiPageHeaderReducer = (state = { type: 'LOADING_COMPASS_KPI_PAGE_HEADER_ACTION', data: {} }, action) => {
//     switch (action.type) {
//         case 'SUCCESS_COMPASS_KPI_PAGE_HEADER_ACTION':
//             return action
//         default:
//             return state
//     }
// }
// const GetCompassSectorBuChartReducer = (state = { type: 'LOADING_COMPASS_SECTOR_BU_CHART_ACTION', data: {} }, action) => {
//     switch (action.type) {
//         case 'SUCCESS_COMPASS_SECTOR_BU_CHART_ACTION':
//             return action
//         default:
//             return state
//     }
// }
// const GetCompassSectorCategoryChartReducer = (state = { type: 'LOADING_COMPASS_SECTOR_CATEGORY_CHART_ACTION', data: {} }, action) => {
//     switch (action.type) {
//         case 'SUCCESS_COMPASS_SECTOR_CATEGORY_CHART_ACTION':
//             return action
//         default:
//             return state
//     }
// }
// const GetCompassCoverageReportChartReducer = (state = { type: 'LOADING_COMPASS_COVERAGE_REPORT_CHART_ACTION', data: {} }, action) => {
//     switch (action.type) {
//         case 'SUCCESS_COMPASS_COVERAGE_REPORT_CHART_ACTION':
//             return action
//         default:
//             return state
//     }
// }
// const GetCompassExecutiveSummaryReducer = (state = { type: 'LOADING_COMPASS_EXECUTIVE_SUMMARY_ACTION', data: {} }, action) => {
//     switch (action.type) {
//         case 'SUCCESS_COMPASS_EXECUTIVE_SUMMARY_ACTION':
//             return action
//         default:
//             return state
//     }
// }

const GetCompassKpiPageHeaderReducer = (state = { type: 'LOADING_COMPASS_KPI_PAGE_HEADER_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_COMPASS_KPI_PAGE_HEADER_ACTION':
            return { ...state, type: 'LOADING_COMPASS_KPI_PAGE_HEADER_ACTION', loading: true };
        case 'SUCCESS_COMPASS_KPI_PAGE_HEADER_ACTION':
            return { ...action, loading: false };
        case 'ERROR_COMPASS_KPI_PAGE_HEADER_ACTION':
            return { ...state, type: 'ERROR_COMPASS_KPI_PAGE_HEADER_ACTION', loading: false, error: action.error };
        case 'RESET_COMPASS_KPI_PAGE_HEADER_ACTION':
            return {
                ...state,
                type: action.payload
            };    
        default:
            return state
    }
}
const GetCompassSectorBuChartReducer = (state = { type: 'LOADING_COMPASS_SECTOR_BU_CHART_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_COMPASS_SECTOR_BU_CHART_ACTION':
            return { ...state, type: 'LOADING_COMPASS_SECTOR_BU_CHART_ACTION', loading: true };
        case 'SUCCESS_COMPASS_SECTOR_BU_CHART_ACTION':
            return { ...action, loading: false };
        case 'ERROR_COMPASS_SECTOR_BU_CHART_ACTION':
            return { ...state, type: 'ERROR_COMPASS_SECTOR_BU_CHART_ACTION', loading: false, error: action.error };
        case 'RESET_COMPASS_SECTOR_BU_CHART_ACTION':
            return {
                ...state,
                type: action.payload
            };    
        default:
            return state
    }
}
const GetCompassSectorCategoryChartReducer = (state = { type: 'LOADING_COMPASS_SECTOR_CATEGORY_CHART_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_COMPASS_SECTOR_CATEGORY_CHART_ACTION':
            return { ...state, type: 'LOADING_COMPASS_SECTOR_CATEGORY_CHART_ACTION', loading: true };
        case 'SUCCESS_COMPASS_SECTOR_CATEGORY_CHART_ACTION':
            return { ...action, loading: false };
        case 'ERROR_COMPASS_SECTOR_CATEGORY_CHART_ACTION':
            return { ...state, type: 'ERROR_COMPASS_SECTOR_CATEGORY_CHART_ACTION', loading: false, error: action.error };
        case 'RESET_COMPASS_SECTOR_CATEGORY_CHART_ACTION':
            return {
                ...state,
                type: action.payload
            };    
        default:
            return state
    }
}
const GetCompassCoverageReportChartReducer = (state = { type: 'LOADING_COMPASS_COVERAGE_REPORT_CHART_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_COMPASS_COVERAGE_REPORT_CHART_ACTION':
            return { ...state, type: 'LOADING_COMPASS_COVERAGE_REPORT_CHART_ACTION', loading: true };
        case 'SUCCESS_COMPASS_COVERAGE_REPORT_CHART_ACTION':
            return { ...action, loading: false };
        case 'ERROR_COMPASS_COVERAGE_REPORT_CHART_ACTION':
            return { ...state, type: 'ERROR_COMPASS_COVERAGE_REPORT_CHART_ACTION', loading: false, error: action.error };
        case 'RESET_COMPASS_COVERAGE_REPORT_CHART_ACTION':
            return {
                ...state,
                type: action.payload
            };    
        default:
            return state
    }
}
const GetCompassExecutiveSummaryReducer = (state = { type: 'LOADING_COMPASS_EXECUTIVE_SUMMARY_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_COMPASS_EXECUTIVE_SUMMARY_ACTION':
            return { ...state, type: 'LOADING_COMPASS_EXECUTIVE_SUMMARY_ACTION', loading: true };
        case 'SUCCESS_COMPASS_EXECUTIVE_SUMMARY_ACTION':
            return { ...action, loading: false };
        case 'ERROR_COMPASS_EXECUTIVE_SUMMARY_ACTION':
            return { ...state, type: 'ERROR_COMPASS_EXECUTIVE_SUMMARY_ACTION', loading: false, error: action.error };
        case 'RESET_COMPASS_EXECUTIVE_SUMMARY_ACTION':
            return {
                ...state,
                type: action.payload
            };    
        default:
            return state
    }
}

const GetCompassDropdownReducer = (state = { type: 'LOADING_COMPASS_DROPDOWN_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_COMPASS_DROPDOWN_ACTION':
            return { ...state, type: 'LOADING_COMPASS_DROPDOWN_ACTION', loading: true };
        case 'SUCCESS_COMPASS_DROPDOWN_ACTION':
            return { ...action, loading: false };
        case 'ERROR_COMPASS_DROPDOWN_ACTION':
            return { ...state, type: 'ERROR_COMPASS_DROPDOWN_ACTION', loading: false, error: action.error };
        case 'RESET_COMPASS_DROPDOWN_ACTION':
            return {
                ...state,
                type: action.payload
            };    
        default:
            return state
    }
}
const GetCompassDropdownV2Reducer = (state = { type: 'LOADING_COMPASS_DROPDOWN_V2_ACTION', data: {} }, action) => {
    switch (action.type) {
        case 'LOADING_COMPASS_DROPDOWN_V2_ACTION':
            return { ...state, type: 'LOADING_COMPASS_DROPDOWN_V2_ACTION', loading: true };
        case 'SUCCESS_COMPASS_DROPDOWN_V2_ACTION':
            return { ...action, loading: false };
        case 'ERROR_COMPASS_DROPDOWN_V2_ACTION':
            return { ...state, type: 'ERROR_COMPASS_DROPDOWN_V2_ACTION', loading: false, error: action.error };
        case 'RESET_COMPASS_DROPDOWN_V2_ACTION':
            return {
                ...state,
                type: action.payload
            };    
        default:
            return state
    }
}

export {
    GetCompassDetailReducer,
    GetCompassCardReducer,
    GetCompassDropdownReducer,
    GetCompassDropdownV2Reducer,
    GetCompassKpiPageHeaderReducer,
    GetCompassSectorBuChartReducer,
    GetCompassSectorCategoryChartReducer,
    GetCompassCoverageReportChartReducer,
    GetCompassExecutiveSummaryReducer
}